// @ts-ignore
import React, {useCallback, useState} from "react";
import {Modal} from "../../../shared";
import {Button} from "../../../ui-components";
import Sentry from "../sentry";
import PayCard from "../PayCard";
import PatientInfo from "../../emergencyCall/PatientInfo";
import PatientInfoScheduled from "../../scheduledCall/PatientInfo";
import PatientCondition from "../../scheduledCall/PatientCondition";
import DestinationsContainer from "../../scheduledCall/DestinationsContainer";
import styles from "./Agreement.module.scss"
import BrigadeItem from "../../brigade/brigadeItem";
import Contract from "./Contract";
import {ArrowLeftIcon, ArrowRightIcon, PlusIcon} from "../../../assets";
import UploadAgreementDocuments from "./UploadAgreementDocuments";
import {useAppDispatch} from "../../../core/hooks";
import {customerContractBeginRequests} from "../../requests/er-thunk";

// @ts-ignore
const Agreement = ({request, selectedModalBrigade, agreementModal, setAgreementModal, emergency_org, emergency_city }) => {
  const [contractTab, setContractTab] = useState(false)
  const [uploadDocuments, setUploadDocuments] = useState(false);

  const [generatedContract, setGeneratedContract] = useState()
  const [generatedInvoice, setGeneratedInvoice] = useState()
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const dispatch = useAppDispatch()
  const handleSubmit = useCallback(() => {

    const formData = new FormData();
    selectedFiles.forEach((file, index) => {
      formData.append('file', file);
    });
    formData.append('file', generatedContract, `договор-${request.sentry_group_uuid}.pdf`)
    if (request.customer_type === 2) {
      formData.append('file', generatedInvoice, `счет-${request.sentry_group_uuid}.pdf`)
    }

    // @ts-ignore
    dispatch(customerContractBeginRequests({
      item: {request_uuid: request?.uuid, customer_uuid: request?.customer_uuid},
      onCloseModal: () => setAgreementModal(false),
      formData
    }));

  },[dispatch, generatedContract, generatedInvoice, request?.customer_uuid, request.sentry_group_uuid, request?.uuid, selectedFiles])
  return  <Modal open={agreementModal}
                 className={styles.modalContainer}
                 closeIcon
                 title={contractTab ? 'Предварительный просмотр' : 'Составить Договор'}
                 handleClose={() => {
                   setAgreementModal(false)
                 }}>
    {!contractTab && !uploadDocuments && <div style={{display: "flex", flexDirection: "column", height: '100%', overflow: "auto"}}>

      <Sentry isEditable={true} request={request}/>
      {request.type ===1 && <PatientInfo isEditable={true} request={request}/>}
      {request.type ===2 && <PatientInfoScheduled isEditable={true} request={request}/>}
      {request.type ===2 && <PatientCondition isEditable={true} request={request}/>}
      {request.type ===2 && <DestinationsContainer isEditable={true} request={request}/>}

      <PayCard request={request} isEditable={false}/>
      {request && request.type ===3 && request?.requestedBrigades?.length > 0 && request?.requestedBrigades.map((el, index) => {
        return <BrigadeItem isEditable={true} request={request} key={index} brigade={el}/>
      })}
    </div>
    }
    {contractTab && <div style={{display: "flex", flexDirection: "column", height: '100%', overflow: "hidden"}}>
      <Contract setGeneratedContract={setGeneratedContract}
                setGeneratedInvoice={setGeneratedInvoice}
                selectedFiles={selectedFiles}
                request={request}
                emergency_org={emergency_org}
                emergency_city={emergency_city}
                setSelectedFiles={setSelectedFiles}/>
    </div>}
    {uploadDocuments && !contractTab && <UploadAgreementDocuments/>}
    {!contractTab && <div className='d-flex flex-end'>
      {/*<Button className={`mt-25`}*/}
      {/*        onClick={() => setUploadDocuments(true)}*/}
      {/*        type='contained'*/}
      {/*        endIcon={<ArrowRightIcon/>}*/}
      {/*>Загрузтить договор</Button>*/}
      <Button className={`mt-25`}
              onClick={() => setContractTab(true)}
              type='contained'
              endIcon={<ArrowRightIcon/>}
      >Далее</Button>
    </div>}
    {contractTab && <div className='d-flex space-between'>
      <Button className={`mt-25`}
              onClick={() => setContractTab(false)}
              type='outlined'
              startIcon={<ArrowLeftIcon/>}
      >Назад</Button>
      <Button className={`mt-25`}
              onClick={handleSubmit}
              type='contained'
              endIcon={<ArrowRightIcon/>}
      >Отправить заказчику</Button>
    </div>}
  </Modal>
}
export default Agreement
